import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getMessaging, getToken, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
  measurementId: process.env.NEXT_PUBLIC_MEASUREMENT_ID,
};

// Initialize Firebase
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();
const auth = getAuth(app);

/**
 * Get FCM device token for push notifications
 * @returns Promise with the FCM token or null if not available
 */
export const getFCMToken = async (): Promise<string | null> => {
  try {
    // Check if messaging is supported (not available in SSR)
    if (typeof window === "undefined") {
      return null;
    }

    const messagingSupported = await isSupported();
    if (!messagingSupported) {
      console.log("Firebase Messaging is not supported in this browser");
      return null;
    }

    const messaging = getMessaging(app);
    const vapidKey = process.env.NEXT_PUBLIC_FIREBASE_CLOUD_MESSAGE_KEY;

    if (!vapidKey) {
      console.error("VAPID key is not configured");
      return null;
    }

    // Request notification permission
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.log("Notification permission not granted");
      return null;
    }

    // Get FCM token
    const currentToken = await getToken(messaging, { vapidKey });

    if (currentToken) {
      console.log("FCM Device token:", currentToken);
      return currentToken;
    } else {
      console.log("No FCM registration token available");
      return null;
    }
  } catch (err) {
    console.error("Error retrieving FCM token:", err);
    return null;
  }
};

export { app, auth };
